import { useMemo } from 'react'
import { useQueries } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchBankPayment } from '../query-api'

interface BankPaymentState {
  cashAccountId?: string
}

export const useFetchBankPayments = (bankPaymentIds: string[]) => {
  const bankPaymentIdsKey = [...new Set(bankPaymentIds)].sort((a, b) => a.localeCompare(b)).join('\0')
  const uniqueBankPaymentIds = useMemo(
    () => (bankPaymentIdsKey ? bankPaymentIdsKey.split('\0') : []),
    [bankPaymentIdsKey],
  )
  const bankPaymentQueriesConfig = useMemo(
    () =>
      uniqueBankPaymentIds.map((bankPaymentId) => ({
        queryFn: () => fetchBankPayment(bankPaymentId),
        queryKey: [QueryKeys.BankPayment, bankPaymentId],
      })),
    [uniqueBankPaymentIds],
  )
  const bankPaymentQueries = useQueries(bankPaymentQueriesConfig)
  const isLoading = bankPaymentQueries.some((query) => query.isLoading)

  const bankPaymentsById = useMemo(
    () =>
      uniqueBankPaymentIds.reduce<Record<string, BankPaymentState>>((result, bankPaymentId, index) => {
        const query = bankPaymentQueries[index]

        result[bankPaymentId] = {
          cashAccountId: query.data?.bankPayment.cashAccountId,
        }

        return result
      }, {}),
    [bankPaymentQueries, uniqueBankPaymentIds],
  )

  return { bankPaymentsById, isLoading }
}
